module.exports = __webpack_public_path__ + "img/sleeve upper arm width.0bd29998.png";